import { Skeleton } from '@mui/material';
import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';
import Avatar from '../Avatar/Avatar';

const MdCheckCircle = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdCheckCircle)
);

const UserAccountWithTick = ({
  userName,
  imagePath,
  accountType,
  role,
  isTicked = false,
  isDefault = false,
}) => {
  const lang = useSelector(({ common }) => common?.language);

  return (
    <div className='flex w-full cursor-pointer items-center justify-between '>
      <div className='flex w-full items-center'>
        <Avatar
          userName={userName}
          imagePath={imagePath}
          height='h-[40px]'
          width='w-[40px]'
        />
        {userName ? (
          <div className='flex flex-col'>
            <p className='mb-0 ml-2 line-clamp-1 max-w-[180px] break-words text-left text-[14px] font-semibold text-black'>
              {userName}
            </p>
            <div className='flex items-center gap-2'>
              <p className='-mt-[3px] mb-0 ml-2 flex text-[12px]  font-normal text-gray-400'>
                {role ? role : accountType}
              </p>
              {/* <p className='-mt-[3px] ml-2 mb-0 flex text-[12px]  font-normal text-gray-400'>
                {accountType}
              </p> */}
              {isDefault ? (
                <div className=' flex h-[19px] w-[50px] items-center justify-center rounded-[100px] bg-[#F6F6F6] px-[8px] py-[2px] text-[11px]'>
                  {lang?.common?.default}
                </div>
              ) : null}
            </div>
          </div>
        ) : (
          <Skeleton
            variant='rectangular'
            className='ml-[8px] h-[40px] w-[140px]'
          />
        )}
      </div>
      {isTicked && <MdCheckCircle className='text-[22px]' />}
    </div>
  );
};

export default UserAccountWithTick;
